// @flow

import * as React from 'react';

import { Outlet } from 'react-router-dom';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';

import { Layout } from '../components/Layout';
import type { WithNeedsAuthProps } from '../types';

type Props = WithNeedsAuthProps;

// eslint-disable-next-line no-unused-vars
const CheckoutIndex = (props: Props) => {
  return (
    <Layout
      backgroundColor="surface"
      lockedOrga
      showCartSummary
      currentStep={3}
    >
      <Outlet />
    </Layout>
  );
};

export default (compose(
  withPageMeta(args => ({
    title: args.__('Choose a payment method - Gandi.net'),
  })),
  needsAuth,
)(CheckoutIndex): React.ComponentType<{}>);
